import React from "react";

const VoiceSelect = ({ currentVoice, changeGender }) => {
  return (
    <section className="voice-select">
      <button
        className={`btn btn-male ${currentVoice === "male" ? "active" : ""}`}
        onClick={(e) => changeGender("Google UK English Male")}
      >
        <i className="fas fa-mars"></i>
      </button>
      <button
        className={`btn btn-female ${
          currentVoice === "female" ? "active" : ""
        }`}
        onClick={(e) => changeGender("Google UK English Female")}
      >
        <i className="fas fa-venus"></i>
      </button>
    </section>
  );
};

export default VoiceSelect;
